export default __webpack_public_path__ + "static/media/battle-zickle.5607c945.png";